import styled from 'styled-components'

export const LogoWrapper = styled.div``
export const Brand = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 1.25rem;
`
